import { useTranslation } from 'react-i18next';
import { useLogger, useUserContext } from '@vp/ubik-context';
import { App } from '../app';
import { sanitiseLocale } from '../app/i18n/config';
import LogomakerClassicPage from '../app/pages/LogomakerClassicPage';
import { DefaultPageTrackingParams } from '../app/utils/analytics';
import type { Logger } from '@vp/ubik-logging';
import type { Translation } from '../@types/resources';
import type { EnvironmentContextType } from '../app/utils/environmentContext';

export interface Props {
    translation: Translation;
    envContext: EnvironmentContextType;
}

const defaultPageTrackingParams: DefaultPageTrackingParams = {
    route: '/logomaker',
};

export const Fragment = ({ translation, envContext }: Props) => {
    const logger: Logger = useLogger();
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(useUserContext().locale);

    logger.info(`Rendering Logomaker fragment for the locale ${locale}`);

    i18n.addResourceBundle(locale, 'translation', translation).changeLanguage(locale);

    return (
        <App
            defaultPageTrackingParams={defaultPageTrackingParams}
            locale={locale}
            envContext={envContext}
        >
            <LogomakerClassicPage />
        </App>
    );
};
